import { render, staticRenderFns } from "./codeDetail.vue?vue&type=template&id=a9e93812&scoped=true"
import script from "./codeDetail.vue?vue&type=script&lang=js"
export * from "./codeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e93812",
  null
  
)

export default component.exports